import Vue from "vue";

import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueGeolocation from "vue-browser-geolocation";

Vue.use(VueGeolocation);

//Vue.prototype.$localhost = "http://localhost";
Vue.prototype.$localhost = "";

Vue.prototype.$idRegistro;

Vue.config.productionTip = false;

new Vue({
    router,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");